import * as React from 'react';
import { observer } from 'mobx-react';

import { UitkRadioGroup, UitkRadio } from 'uitk-react-switch';
import { getInfantOptionsDataTestId } from 'utility';

import {
  FlightsSearchFormTravelerInfantsSelection,
  TravelerOptionItem,
  FlightsSearchFormTravelerInfantOptionItem
} from 'types/search/wizard';
import { FlightsTravelerType } from '__generated__/api';

export interface TravelerInfantOptionsProps {
  travelerOptionItem: TravelerOptionItem;
  searchOptionTypeName: string;
}

export const TravelerInfantOptions = observer(({ travelerOptionItem }: TravelerInfantOptionsProps) => {
  const { infantsOption } = travelerOptionItem as FlightsSearchFormTravelerInfantOptionItem;

  if (!infantsOption) {
    return null;
  }

  const { items, label } = infantsOption;
  const selectedItem = items.find((item: FlightsSearchFormTravelerInfantsSelection) => item.selected);
  const selectedType = selectedItem && selectedItem.type;
  const onChange = (event: React.ChangeEvent) => {
    const { value } = event.target as HTMLInputElement;
    const previousSelection = items.find((item: FlightsSearchFormTravelerInfantsSelection) => item.selected);
    if (previousSelection) {
      previousSelection.selected = false;
    }

    const newSelection = items.find((item: FlightsSearchFormTravelerInfantsSelection) => item.type === value);
    newSelection.selected = true;

    travelerOptionItem.type = value as FlightsTravelerType;
  };

  return (
    <div className="all-y-margin-two">
      <fieldset>
        <legend
          className="uitk-type-400 uitk-type-bold s-t-padding-two m-t-padding-two s-b-padding-three m-b-padding-three"
          aria-hidden="true"
        >
          {label}
        </legend>
        <UitkRadioGroup group={label} selected={selectedType} onChange={onChange}>
          {items.map((item: FlightsSearchFormTravelerInfantsSelection) => {
            const { label: radioButtonLabel, type } = item;
            const key = `${type}-radio-button`;
            const dataTestId = `${getInfantOptionsDataTestId(type)}-radio-btn`;

            return <UitkRadio id={type} key={key} value={type} label={radioButtonLabel} data-test-id={dataTestId} />;
          })}
        </UitkRadioGroup>
      </fieldset>
    </div>
  );
});
